// import { Download, RotateCcw, Search, Undo2 } from 'lucide-react'
// import React from 'react'

// function CustomPageHeader({title,setText,text,handleSearch,onClick,btnText,handleBackClick,handleDownload}) {

//   return (
//     <header className="bg-white shadow">
//     <div className="mx-auto py-6 px-4 sm:px-6 lg:px-8">
//       <div className="flex flex-col md:flex-row md:items-center md:justify-between">
//         <div className='flex gap-1 items-center'>
//         <button className='flex gap-1 px-3 py-1 rounded-lg'  onClick={handleBackClick}>
//         <Undo2 />
//         {/* <RotateCcw /> */}
//         <span>Back</span>
//         </button>
//         <h1 className="text-3xl font-bold text-gray-900 mb-4 md:mb-0">{title}</h1>
//         </div>
//         <div className="flex flex-col sm:flex-row gap-4">
//           <div className="relative">
//             <input
//               type="text"
//               placeholder="Search users..."
//               className="border rounded-md px-4 py-2 w-full sm:w-64"
//               value={text}
//               onChange={(e) => setText(e.target.value)}
//             />
//             <button className='absolute right-2 top-[50%] translate-y-[-50%]' onClick={handleSearch} disabled={text===''}>
//             <Search className="text-indigo-700 "/>
//             </button>
            
//           </div>
//           <div className="flex gap-2">
//             <button
//               onClick={handleDownload}
//               className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded flex gap-1"
//             >
//              <Download/>
//               <span>Download</span>
//             </button>
//             <button
//               onClick={onClick}
//               className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
//             >
//               {btnText}
//             </button>
//             <button
//               onClick={handleDownload}
//               className="bg-white border border-indigo-200 hover:bg-yellow-300 hover:border-yellow-300 text-gray-800 font-bold py-2 px-4 rounded flex gap-1"
//             >
//              <RotateCcw/>
//               <span>Refresh</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   </header>
//   )
// }

// export default CustomPageHeader


import { Download, RotateCcw, Search, Undo2 } from 'lucide-react';
import React from 'react';

function CustomPageHeader({
  title,
  setText,
  text,
  handleSearch,
  onClick,
  btnText,
  handleBackClick,
  handleDownload,
  handleRefresh
}) {
  return (
    <header className="bg-white shadow">
      <div className="mx-auto py-4 px-4 sm:px-6 lg:px-8 overflow-x-auto">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          {/* Back Button and Title */}
          <div className="flex flex-col gap-2 md:flex-row md:items-center">
            <button
              className="flex items-center gap-1 px-3 py-1 rounded-lg bg-gray-100 hover:bg-gray-200"
              onClick={handleBackClick}
            >
              <Undo2 />
              <span>Back</span>
            </button>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          </div>

          {/* Search and Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 items-center w-full md:w-auto">
            {/* Search Input */}
            <div className="relative w-full sm:w-auto">
              <input
                type="text"
                placeholder="Search users..."
                className="border rounded-md px-4 py-2 w-full sm:w-64"
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
              <button
                className="absolute right-2 top-[50%] translate-y-[-50%] text-indigo-700 whitespace-nowrap"
                onClick={handleSearch}
                disabled={text === ''}
              >
                <Search />
              </button>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap justify-center sm:justify-start md:flex-nowrap gap-2">
              <button
                onClick={handleDownload}
                className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded flex items-center gap-1 whitespace-nowrap"
              >
                <Download />
                <span>Download</span>
              </button>
              <button
                onClick={onClick}
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded whitespace-nowrap"
              >
                {btnText}
              </button>
              <button
                onClick={handleRefresh}
                className="bg-white border border-indigo-200 hover:bg-yellow-300 hover:border-yellow-300 text-gray-800 font-bold py-2 px-4 rounded flex items-center gap-1 whitespace-nowrap"
              >
                <RotateCcw />
                <span>Refresh</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default CustomPageHeader;

